module.exports = __webpack_public_path__ + "images/company_profile/icon_en04-4a87cd32a3ccb75551445e5e1b4c3f1b.png";